// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1RxXE","label":"Category_label__2IkMZ","content":"Category_content__2eeDG","header":"Category_header__1VKLc","location":"Category_location__NPu3-"};